import { Pagination, createTable } from "@inmagik/magik-ui"
import { useMemo, useState } from "react"
import type { FiltersBase, Media } from "../../types"
import { MEDIA_TYPES, PAGE_SIZE } from "../../constants"
import { Link } from "react-router-dom"

const Table = createTable<Media>()

export function TableMedia({
  media,
  setFilters,
  filters,
  count,
  fullCount,
}: {
  media: Media[]
  setFilters: (nextFilters: Partial<FiltersBase>) => void
  filters: FiltersBase
  count: number
  fullCount: number
}) {
  // const [sort, setSort] = useState<string>("")
  const [selectedRows, setSelectedRows] = useState<number[]>([])

  const numPages = useMemo(() => {
    if (!media) {
      return 1
    }
    return Math.ceil(count / PAGE_SIZE)
  }, [media, count])

  return (
    <Table
      data={media}
      className="w-100 overflow-scroll flex-1"
      orderBy={filters.ordering.replace("-", "")}
      orderDirection={filters.ordering.startsWith("-") ? "desc" : "asc"}
      onOrderChange={(field, direction) => {
        if (field) {
          if (direction === "desc") {
            setFilters({ ...filters, ordering: `-${field}` })
          } else {
            setFilters({ ...filters, ordering: field })
          }
        } else {
          setFilters({ ...filters, ordering: "" })
        }
      }}
    >
      <Table.HeaderConfig sticky />

      <Table.BodyConfig />

      <Table.Selection
        selectionField="id"
        selectedRows={selectedRows}
        onSelectionChange={(rows) => {
          setSelectedRows(rows)
        }}
      />

      <Table.Column
        title="Immagine"
        name="media_file"
        sortable
        width="minmax(max-content, 1fr)"
        render={(media) => (
          <Link to={`/media/media/${media.id}`}>
            {media.thumbnail && (
              <img
                src={media.thumbnail}
                alt={media.title}
                style={{ maxWidth: 100, maxHeight: 100 }}
              />
            )}
          </Link>
        )}
        stickyLeft
      />

      <Table.Column
        title="Tipo media"
        name="media_type"
        sortable
        width="minmax(max-content, 1fr)"
        render={(media) => <span>{MEDIA_TYPES.find((type) => type.value === media.media_type)?.label || "N/A"}</span>}
      />

      <Table.Column
        title="Sorgente file"
        name="name_file"
        sortable
        width="minmax(400px, 1fr)"
        render={(media) =>
          // get the name from media.media_file
          <span dangerouslySetInnerHTML={{ __html: media.source || "N/A" }} />
        }
      />

      <Table.Footer.Left>
        Stai visualizzando {count} di {fullCount} media
      </Table.Footer.Left>
      <Table.Footer.Center>
        <Pagination page={filters.page} numPages={numPages} onPageChange={(page) => setFilters({ ...filters, page })} />
      </Table.Footer.Center>
    </Table>
  )
}
